import { z } from 'zod';

export const UserDto = z.object({
  userId: z.string().uuid(),
  displayName: z.string(),
  // Avatar initials, computed by the API from the AD name parts
  // (api/src/repositories/person.ts). The web renders this verbatim and
  // must never derive initials itself.
  initials: z.string(),
  email: z.string(),
  utEid: z.string().nullable(),
});
export type UserDto = z.infer<typeof UserDto>;
